import { withTranslation } from 'react-i18next';
import Component from '../../components/Component';

class Steps extends Component {
    constructor() {
        super();
    }

    render() {
        const { t } = this.props;
        return (
            <div className="google-discover-steps">
                <div className="google-discover-steps-header">
                    <img src="/static/img/google_discover.svg" loading="lazy" alt="img" />
                    {t('discover.overview.steps.header')}
                </div>
                <div className="google-discover-steps-body">
                    <div className="google-discover-steps-body-item">
                        <div className="google-discover-steps-body-item-header">
                            <div className="google-discover-steps-body-item-header-img">
                                <img
                                    src={
                                        this.state.isDark
                                            ? '/static/img/grid-01_dark.svg'
                                            : '/static/img/grid-01.svg'
                                    }
                                    loading="lazy"
                                    alt="img"
                                />
                            </div>
                            <a
                                target="_blank"
                                href={`${this.props.url}/categories/`}
                                rel="noreferrer"
                            >
                                <strong>{t('discover.overview.steps.step_1.header')}</strong>
                            </a>
                        </div>
                        <div className="google-discover-steps-body-item-body">
                            {t('discover.overview.steps.step_1.body')}
                        </div>
                    </div>
                    <div className="google-discover-steps-body-item">
                        <div className="google-discover-steps-body-item-header">
                            <div className="google-discover-steps-body-item-header-img">
                                <img
                                    src={
                                        this.state.isDark
                                            ? '/static/img/thumbs-up_dark.svg'
                                            : '/static/img/thumbs-up.svg'
                                    }
                                    loading="lazy"
                                    alt="img"
                                />
                            </div>
                            <a
                                target="_blank"
                                href={`${this.props.url}/entities/`}
                                rel="noreferrer"
                            >
                                <strong>{t('discover.overview.steps.step_2.header')}</strong>
                            </a>
                        </div>
                        <div className="google-discover-steps-body-item-body">
                            {t('discover.overview.steps.step_2.body')}
                        </div>
                    </div>
                    <div className="google-discover-steps-body-item">
                        <div className="google-discover-steps-body-item-header">
                            <div className="google-discover-steps-body-item-header-img">
                                <img
                                    src={
                                        this.state.isDark
                                            ? '/static/img/notification-text_dark.svg'
                                            : '/static/img/notification-text.svg'
                                    }
                                    loading="lazy"
                                    alt="img"
                                />
                            </div>
                            <a target="_blank" href={`${this.props.url}/authors/`} rel="noreferrer">
                                <strong>{t('discover.overview.steps.step_3.header')}</strong>
                            </a>
                        </div>
                        <div className="google-discover-steps-body-item-body">
                            {t('discover.overview.steps.step_3.body')}
                        </div>
                    </div>
                    <div className="google-discover-steps-body-item">
                        <div className="google-discover-steps-body-item-header">
                            <div className="google-discover-steps-body-item-header-img">
                                <img
                                    src={
                                        this.state.isDark
                                            ? '/static/img/n_author-performance_dark.svg'
                                            : '/static/img/n_author-performance.svg'
                                    }
                                    loading="lazy"
                                    alt="img"
                                />
                            </div>
                            <a
                                target="_blank"
                                href={`${this.props.url}/opportunities/recommendations/`}
                                rel="noreferrer"
                            >
                                <strong>{t('discover.overview.steps.step_4.header')}</strong>
                            </a>
                        </div>
                        <div className="google-discover-steps-body-item-body">
                            {t('discover.overview.steps.step_4.body')}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(Steps);
